import VipProductList from "../views/productManagement/vipProductList";
import VipProductRightList from "../views/productManagement/VipProductRightList";
import GlodList from "../views/productManagement/glodList";
// import GameGlodList from "../views/productManagement/gameGlodList";
// import GlodPayList from "../views/productManagement/glodPayList";
// import PromoteUrl from "../views/productManagement/promoteUrl";
// import PayMethod from "../views/productManagement/payMethod";
// import VipCfg from "../views/productManagement/vipCfg";
// import ProductPositionList from "../views/productManagement/productPositionList";
import Main from "../views/main";
import JDDistrictCfg from "../views/productManagement/jdDistrictCfg";
import CheckRewards from "../views/productManagement/checkrewards";
import CheckTasks from "../views/productManagement/checktasks";
import CheckPrize from "../views/productManagement/checkprize";
import HotTag from "../views/productManagement/hottag";
import SysMsg from "../views/productManagement/sysmsg";
import AnnouncementManagement from '../views/productManagement/announcementManagement'
import FixedAdManagement from '../views/productManagement/fixedAdManagement'
import FixedMessageManagement from '../views/productManagement/fixedMessageManagement'
import TechnologyManagement from '../views/productManagement/technology'
// import TechnologyStatManagement from '../views/productManagement/technology/stat'


const ProductRouter = {
    path: "/vip-product-list",
    component: Main,
    title: "产品配置",
    icon: "el-icon-s-order",
    meta: {keepAlive: false},
    children: [
        {
            path: "/vip-product-list",
            component: VipProductList,
            name: "vipProductList",
            title: "VIP会员卡",
            meta: {title: "VIP会员卡", keepAlive: false},
        },
        {
            path: "/vip-product-right-list",
            component: VipProductRightList,
            name: "vipProductRightList",
            title: "VIP权益列表",
            meta: {title: "VIP权益列表", keepAlive: false},
        },
        {
            path: "/glod-list",
            component: GlodList,
            name: "glod-list",
            title: "金币列表",
            meta: {title: "金币列表", keepAlive: false},
        },
        // {
        //     path: "/gameGlod-list",
        //     component: GameGlodList,
        //     name: "gameGlod-list",
        //     title: "游戏金币列表",
        //     meta: {title: "游戏金币列表", keepAlive: false},
        // },
        // {
        //     path: "/glod-pay-list",
        //     component: GlodPayList,
        //     name: "glod-pay-list",
        //     title: "金币优惠配置",
        //     meta: {title: "金币优惠配置", keepAlive: false},
        // },
        // {
        //     path: "/promote-url",
        //     component: PromoteUrl,
        //     name: "promote-url",
        //     title: "推广落地页配置",
        //     meta: {title: "推广落地页配置", keepAlive: false},
        // },
        // {
        //     path: "/pay-method",
        //     component: PayMethod,
        //     name: "payMethod",
        //     title: "充值渠道管理",
        //     meta: {title: "充值渠道管理", keepAlive: false},
        // },
        // {
        //     path: "/productPosition-list",
        //     component: ProductPositionList,
        //     name: "productPositionList",
        //     title: "产品位置配置",
        // },
        // {
        //     path: "/vip_Cfg",
        //     component: VipCfg,
        //     name: "vipCfg",
        //     title: "VIP升级配置",
        // },
        {
            path: "/JG_district_config",
            component: JDDistrictCfg,
            name: "JGDistrictCfg",
            title: "金刚区配置",
        },
        {
            path: "/check_rewards",
            component: CheckRewards,
            name: "CheckRewards",
            title: "签到配置",
        },
        {
            path: "/check_tasks",
            component: CheckTasks,
            name: "CheckTasks",
            title: "福利任务配置",
        },
        {
            path: "/check_prize",
            component: CheckPrize,
            name: "CheckTasks",
            title: "积分兑换配置",
        },
        {
            path: "/hottag",
            component: HotTag,
            name: "HotTag",
            title: "热搜关键词",
        },
        {
            path: "/sysmsg",
            component: SysMsg,
            name: "SysMsg",
            title: "系统消息",
        },
        {
            path: '/fannouncement-Management',
            component: AnnouncementManagement,
            name: 'announcementManagement',
            title: '公告管理',
            meta: { title: '公告管理' ,keepAlive: false }
        },
        {
            path: '/fixead-Management',
            component: FixedAdManagement,
            name: 'fixedAdManagement',
            title: '浮窗广告管理',
            meta: { title: '浮窗广告管理' ,keepAlive: false }
        },
        {
            path: '/fixedmessage-Management',
            component: FixedMessageManagement,
            name: 'fixedMessageManagement',
            title: '跑马灯管理',
            meta: { title: '跑马灯管理' ,keepAlive: false }
        },
        {
            path: '/technology',
            component: TechnologyManagement,
            name: 'technologyManagement',
            title: '导航广告',
            meta: { title: '导航广告' ,keepAlive: false }
        },
        // {
        //     path: '/technologystat',
        //     component: TechnologyStatManagement,
        //     name: 'technologyStatManagement',
        //     title: '导航统计',
        //     meta: { title: '导航统计' ,keepAlive: false }
        // }

        // {
        //   path: "/duicode",
        //   component: CheckPrize,
        //   name: "CheckTasks",
        //   title: "兑换码",
        // },
    ],
};
export default ProductRouter;
